<template>
  <div class="container">
    <img class="lunch_item" src="../../../assets/images/activity/202107/1.png" />
    <img @click="reLaunchVip()" class="lunch_btn" src="../../../assets/images/activity/202107/btn.png" />
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() {

    },
    mounted() { },
    methods: {
      reLaunchVip(){
        wx.miniProgram.reLaunch({
          url:'/pages/vip/vip'
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .lunch_item{
    width: 100%;
  }
  .lunch_btn{
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 824*@vm_base;
    width: calc(100% - 324*@vm_base);
    margin-left: 162*@vm_base;

  }
</style>



// WEBPACK FOOTER //
// src/components/activity/buycardgift/lunchbox.vue